import React from "react";
import "./App.css";
import { Helmet } from "react-helmet";
import { Link, Button } from '@mui/material';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import Logo from './Images/savetheseaturtlelogo.webp'

const theme = createTheme({
  palette: {
    primary: {
      main: "#99aab5", // custom primary color
    },
    secondary: {
      main: "#F27920", // custom secondary color
    },
  },
});


export default function Home() {
  return (
    <div>

      <Helmet>
        <title data-react-helmet="true"></title>
        <meta data-react-helmet="true" name="description" content="" />
        <meta data-react-helmet="true" property="og:title" content="" />
        <meta data-react-helmet="true" property="og:type" content="" />
        <meta data-react-helmet="true" property="og:url" content="" />
        <meta data-react-helmet="true" property="og:image" content="" />
        <meta data-react-helmet="true" property="og:description" content="" />
      </Helmet>

      <div className="lg:flex bg-white">

        <div>
          <div className="p-20">
            <div className="text-center text-xl text-[#F27920] font-bold">Introducing Our New Logo</div>
            <div >
              <img
                src={Logo}
                alt="National Save The Sea Turtle Foundation Logo"
                title="National Save The Sea Turtle Foundation"
                className="p-5 mx-auto"

              />
            </div>
            <p>
              The Foundation's mission remains unchanged: To support researchers, educators, and conservationists that focus on ensuring the future of the world's sea turtles.
            </p>
            <p className="py-4">
              “This new brand identity represents more than just a visual update; it's a reflection of our growth and unwavering dedication to protecting sea turtles and their ecosystems,” says Dr.  Larry Wood, Executive Director.
            </p>

            <div className="pt-4 pb-3">
              <div className="lg:flex gap-5">
                <div className="lg:w-1/2 text-center mx-auto">
                  <div className="mx-auto text-center">
                    <div className="mx-auto text-center pt-4 pb-3">
                      <ThemeProvider theme={theme}>
                        <Link href="https://savetheseaturtle.org/forms/cashdonation.html" target="_blank" rel="noopener noreferrer" style={{ color: "#ffffff" }}>
                          <Button color="secondary" variant="contained" fullWidth style={{ color: '#ffffff' }}>
                            <div>
                              <div className="text-center"><VolunteerActivismIcon fontSize="large" /></div>
                              <div className="text-center font-bold pt-2">Donate and Become a Member Today!</div>
                            </div>
                          </Button>
                        </Link>
                      </ThemeProvider>
                    </div>
                  </div>
                </div>
                <div className="lg:w-1/2 text-center">
                  <div className="mx-auto text-center">
                    <div className="mx-auto text-center pt-4 pb-3">
                      <ThemeProvider theme={theme}>
                        <Link href="https://savetheseaturtle.org/forms/cashdonation.html" target="_blank" rel="noopener noreferrer" style={{ color: "#ffffff" }}>
                          <Button color="secondary" variant="contained" fullWidth style={{ color: '#ffffff' }}>
                            <div>
                              <div className="text-center"><VolunteerActivismIcon fontSize="large" /></div>
                              <div className="text-center font-bold pt-2">Become a Corporate Partner Today!</div>
                            </div>
                          </Button>
                        </Link>
                      </ThemeProvider>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >


    </div >
  );
}
